<div class="form-control-container">
  <label class="form-control-label" for="datepicker" style="position: relative">
    {{ isRequired ? label + ' *' : label }}
  </label>

  <p-datepicker
    #calendar
    [minDate]="minDate"
    [maxDate]="maxDate"
    [showTime]="showTimePicker"
    [formControl]="dateControl"
    [iconDisplay]="'input'"
    [showIcon]="true"
    [readonlyInput]="true"
    [dateFormat]="dateFormat"
    [firstDayOfWeek]="1"
    (onShow)="onCalendarShow()"
    [appendTo]="appendToBody ? 'body' : null"
  ></p-datepicker>
</div>
